/* eslint-disable react/prop-types */
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
  Typography,
  Select,
  notification,
  Tag,
  Row,
  Col,
} from 'antd';
import { Button as CrcButton, Spinner } from '@crc-evans/ui-components';
import { CalendarOutlined, CaretDownOutlined, CaretUpOutlined, CloseOutlined } from '@ant-design/icons';
import { Plus } from 'lucide-react';
import { get, set } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import ExcelJS from 'exceljs';
import moment from 'moment';
import history from '../../services/history';
import ProjectDetails from './ProjectDetails';
import DcalUpdateForm from './DcalUpdateForm';
import { fetchProjectList } from '../../redux/DCAL/action';
import DCalMasteForm from './DCalMasteForm';
import { DeleteProjectDetails } from '../../redux/DCAL/saga';
import { getAccess } from '../../services/teamMembers';
import { authenticateCurrentUser } from '../../services/auth';
import '../Materials/MaterialsModal.css';

const { Option } = Select;
const { Title, Text } = Typography;

const DCalPage = (props) => {
  const { onProjectList, projectList, isLoading, listCount, embeddedInModernLayout = false } = props;
  const [projectDetailForm] = Form.useForm();
  const [showGenerateModel, setShowGenerateModel] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const [showPipelineModel, setShowPipelineModel] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editRecord, seteditRecord] = useState('');
  const [showMasterModel, setShowMasterModel] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [selectedPDFData, setSelectedPDFData] = useState('');

  const [projectDetails, setProjectDetails] = useState({
    key: '1',
    ProjectName: 'Project A',
    ProjectNumber: 'P123',
    Matrial: 'FBE',
    CreatedBy: 'sella',
    CreationDate: '2024-06-19',
    project_type: 'onshore',
    number_of_joints: 3,
    project_duration: 5,

    // Add other properties as needed
  });
  const materialClassOptions = [
    'FBE',
    'Liquid Epoxy',
    'Single Layer FBE',
    ,
    'Dual Layer FBE',
    'Others',
  ];
  const data = [
    {
      key: '1',
      project_name: 'Project A',
      project_number: 'P123',
      material: 'FBE',
      created_by: 'sella',
      created_date: '2024-06-19',
      project_type: 'onshore',
      number_of_joints: 3,
      project_duration: 5,

      // Add other properties as needed
    },
    {
      key: '1',
      project_name: 'Project B',
      project_number: 'P789',
      material: 'FBE',
      created_by: 'Vinay',
      created_date: '2024-06-18',
      project_type: 'offshore',
      number_of_joints: 2,
      project_duration: 10,
      // Add other properties as needed
    },
    // Add more objects as needed
  ];

  const [searchCriteria, setSearchCriteria] = useState({});
  const [filterCreatedDate, setFilterCreatedDate] = useState(null);
  const [columnFilters, setColumnFilters] = useState({
    project_name: '',
    project_number: '',
    material: '',
    project_type: '',
    project_duration: '',
    number_of_joints: '',
    created_by: '',
  });
  const [userName, setUserName] = useState('');
  const [userGroup, setUserGroup] = useState([]);
  /** get user Access */
  useEffect(() => {
    const UserGroup = localStorage.getItem('UserGroup') ?? [];
    if (!UserGroup || UserGroup.length === 0) {
      authenticateCurrentUser()
        .then(async (data) => {
          let response = await getAccess(data.username);
          const userAccess = response.map((item) => item?.GroupName);
          setUserName(data.username);
          setUserGroup(userAccess);
          localStorage.setItem('UserGroup', userAccess);
          setUserGroup(UserGroup);
        })
        .catch((error) => {
          console.log('error', error);
        });
    } else setUserGroup(UserGroup);
  }, [history]);
  const downloadedFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    // link.download = 'image.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const columns_feild = [
    {
      title: 'Project Name',
      dataIndex: 'project_name',
      key: 'project_name',
      ellipsis: true,
      render: (text) => <a title={text}>{text === ' ' ? '-' : (text || '-')}</a>,
      align: 'left',
    },

    {
      title: 'Project Number',
      dataIndex: 'project_number',
      key: 'project_number',

      //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
      render: (text) => <a>{text === ' ' ? '-' : text}</a>,
      align: 'center',
    },
    {
      title: 'Material',
      dataIndex: 'material',
      key: 'material',

      //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
      render: (text) => <a>{text === ' ' ? '-' : text}</a>,
      align: 'center',
    },

    {
      title: 'Project Type',
      dataIndex: 'project_type',
      key: 'project_type',

      //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
      render: (text) => <a>{text === ' ' ? '-' : text}</a>,
      align: 'center',
    },
    {
      title: 'Project Duration',
      dataIndex: 'project_duration',
      key: 'project_duration',

      //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
      render: (text) => <a>{text === ' ' ? '-' : text}</a>,
      align: 'center',
    },
    {
      title: 'No. of Joints',
      dataIndex: 'number_of_joints',
      key: 'number_of_joints',

      //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
      render: (text) => <a>{text === ' ' ? '-' : text}</a>,
      align: 'center',
    },

    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      align: 'center',
      // width: '150px',
      //sorter: (a, b) =>  (a.License_File_Name.localeCompare(b.License_File_Name)),
      render: (text) => <a>{text === 'undefined' ? '-' : text}</a>,
    },

    {
      title: 'Created Date',
      dataIndex: 'created_date',
      key: 'created_date',
      align: 'center',
      render: (text) => {
        return <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>;
      },
      // sorter: (a, b) => moment(a.File_Creation_Date).valueOf() - moment(b.File_Creation_Date).valueOf()
    },

    {
      title: 'Report',
      dataIndex: 'report',
      key: 'report',
      align: 'center',
      render: (text, record) => (
        <div className="heat-profile-files-cell heat-profile-actions-cell">
          {record.PDF_Files_History && record.PDF_Files_History[0].PDFFileLink && (
            <Tooltip title="Download PDF file">
              <FilePdfOutlined
                className="txtIcon"
                onClick={() => onClickPDFView(record)}
              />
            </Tooltip>
          )}
          {record.Excel_Files_History && record.Excel_Files_History[0].ExcelFileLink && (
            <Tooltip title="Download Excel file">
              <FileExcelOutlined
                className="txtIcon"
                onClick={() => downloadedFile(record.Excel_Files_History[0].ExcelFileLink)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit_delete',
      key: 'edit_delete',
      align: 'center',
      render: (text, record) => (
        <div className="heat-profile-actions-cell">
          <Tooltip title="Update">
            <EditOutlined
              className="txtIcon"
              onClick={() => onUpdateClick(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              className="txtIcon"
              onClick={() => showDeleteModal(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Plain column headers for modern layout (no filters in header)
  const columnsPlainTitles = [
    'PROJECT NAME',
    'PROJECT NUMBER',
    'MATERIAL',
    'PROJECT TYPE',
    'PROJECT DURATION',
    'NO. OF JOINTS',
    'CREATED BY',
    'CREATED DATE',
    'REPORT',
    'ACTIONS',
  ];
  const modernColumns = columns_feild.map((col, idx) => ({
    ...col,
    title: columnsPlainTitles[idx] || col.title,
    width: col.dataIndex === 'report' || col.dataIndex === 'edit_delete' ? 120 : col.dataIndex === 'project_name' ? 200 : undefined,
    ...(col.dataIndex === 'project_name' && { minWidth: 200 }),
  }));

  // Heat Profile-style columns: two-row header with per-column filters (modern layout only)
  const textFilterKeys = [
    'project_name',
    'project_number',
    'material',
    'project_type',
    'project_duration',
    'number_of_joints',
    'created_by',
  ];
  /* Min widths so header label + sort icon + gap fit without truncation (production-ready) */
  const columnMinWidths = {
    project_name: 160,
    project_number: 150,
    material: 120,
    project_type: 140,
    project_duration: 160,
    number_of_joints: 140,
    created_by: 130,
    created_date: 150,
    report: 100,
    edit_delete: 120,
  };
  const modernColumnsWithFilters = columns_feild.map((col, idx) => {
    const dataIndex = col.dataIndex;
    const isReport = dataIndex === 'report';
    const isActions = dataIndex === 'edit_delete';
    const isCreatedDate = dataIndex === 'created_date';
    const isTextFilter = textFilterKeys.includes(dataIndex);

    let title = columnsPlainTitles[idx] || col.title;
    if (isTextFilter) {
      title = (
        <div className="column-header-with-filter">
          <div className="column-header-text-wrapper">
            <span>{columnsPlainTitles[idx]}</span>
            <span
              className="custom-sort-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleSortClick(dataIndex); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortClick(dataIndex); } }}
            >
              {sortField === dataIndex && sortOrder === 'ascend' && <CaretUpOutlined />}
              {sortField === dataIndex && sortOrder === 'descend' && <CaretDownOutlined />}
              {(!sortField || sortField !== dataIndex || !sortOrder) && (
                <span className="sort-icon-placeholder"><CaretUpOutlined /></span>
              )}
            </span>
          </div>
          <div className="header-filter-input">
            <Input
              placeholder="Search"
              size="small"
              value={columnFilters[dataIndex] || ''}
              onChange={(e) => handleColumnFilterChange(dataIndex, e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      );
    } else if (isCreatedDate) {
      title = (
        <div className="column-header-with-filter">
          <div className="column-header-text-wrapper">
            <span>CREATED DATE</span>
            <span
              className="custom-sort-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleSortClick('created_date'); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortClick('created_date'); } }}
            >
              {sortField === 'created_date' && sortOrder === 'ascend' && <CaretUpOutlined />}
              {sortField === 'created_date' && sortOrder === 'descend' && <CaretDownOutlined />}
              {(!sortField || sortField !== 'created_date' || !sortOrder) && (
                <span className="sort-icon-placeholder"><CaretUpOutlined /></span>
              )}
            </span>
          </div>
          <div className="header-filter-input">
            <DatePicker
              className="heat-profile-header-date-picker"
              placeholder="Select date"
              size="small"
              format="DD-MMM-YYYY"
              value={filterCreatedDate}
              onChange={(date) => setFilterCreatedDate(date)}
              onClick={(e) => e.stopPropagation()}
              suffixIcon={
                filterCreatedDate ? (
                  <CloseOutlined
                    className="heat-profile-date-clear-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCreatedDate(null);
                    }}
                  />
                ) : (
                  <CalendarOutlined className="heat-profile-date-icon" />
                )
              }
              dropdownClassName="heat-profile-datepicker-dropdown"
              allowClear={false}
            />
          </div>
        </div>
      );
    }
    const isSortable = !isReport && !isActions;
    const minW = columnMinWidths[dataIndex];
    const baseCol = {
      ...col,
      title,
      width: minW,
      minWidth: minW,
      ...(isSortable && { sorter: true, sortOrder: sortField === dataIndex ? sortOrder : undefined }),
    };
    if (isReport || isActions) {
      baseCol.filters = undefined;
      baseCol.onFilter = undefined;
      baseCol.filterDropdown = undefined;
    }
    return baseCol;
  });

  function hasNonEmptyTag(jsonObj) {
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        const value = jsonObj[key];

        if (value.trim() !== '') {
          return true;
        }
      }
    }
    return false;
  }

  // Sync column filters and created date to searchCriteria for API (modern layout)
  useEffect(() => {
    const criteria = {};
    Object.keys(columnFilters || {}).forEach((key) => {
      const val = (columnFilters[key] || '').trim();
      if (val) criteria[key] = val;
    });
    if (filterCreatedDate) criteria.created_date = moment(filterCreatedDate).format('YYYY-MM-DD');
    setSearchCriteria((prev) => {
      const a = JSON.stringify(prev);
      const b = JSON.stringify(criteria);
      if (a === b) return prev;
      return criteria;
    });
  }, [columnFilters, filterCreatedDate]);

  const normalizeSearchCriteria = (criteria = {}) => {
    const normalized = { ...criteria };
    ['project_duration', 'number_of_joints'].forEach((key) => {
      const raw = normalized[key];
      if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
        const parsed = Number(raw);
        if (!Number.isNaN(parsed)) normalized[key] = parsed;
      }
    });
    return normalized;
  };

  const buildProjectListRequest = () => {
    const isvalid = hasNonEmptyTag(searchCriteria);
    const hasSearchKey = searchCriteria && Object.keys(searchCriteria).length > 0;
    const obj = {
      pageSize: isvalid ? 10 : currentPagesize,
      pageNumber: isvalid ? 1 : currentPageNumber,
    };
    if (hasSearchKey) {
      obj.searchKey = normalizeSearchCriteria(searchCriteria);
    }
    return obj;
  };

  /* Fetch when filters/search criteria change. Pagination uses table onChange (avoids double request). */
  useEffect(() => {
    onProjectList(buildProjectListRequest());
  }, [searchCriteria]);

  const skipPipelineModalListFetchOnMount = useRef(true);
  useEffect(() => {
    if (skipPipelineModalListFetchOnMount.current) {
      skipPipelineModalListFetchOnMount.current = false;
      return;
    }
    if (!showPipelineModel) {
      onProjectList(buildProjectListRequest());
    }
  }, [showPipelineModel]);

  const handleSortClick = (columnKey) => {
    setSortField(columnKey);
    setSortOrder((prev) => (sortField === columnKey && prev === 'ascend' ? 'descend' : 'ascend'));
    setCurrentPageNumber(1);
  };

  /* Client-side sorted data for DCAL table (backend does not support sort) */
  const sortedProjectList = useMemo(() => {
    if (!projectList || !Array.isArray(projectList) || !sortField || !sortOrder) {
      return projectList ? [...projectList] : [];
    }
    const isDesc = sortOrder === 'descend';
    const dateKeys = ['created_date'];
    const numKeys = ['project_duration', 'number_of_joints'];
    return [...projectList].sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];
      if (dateKeys.includes(sortField)) {
        aVal = aVal ? moment(aVal).valueOf() : 0;
        bVal = bVal ? moment(bVal).valueOf() : 0;
        return isDesc ? bVal - aVal : aVal - bVal;
      }
      if (numKeys.includes(sortField)) {
        const aNum = Number(aVal);
        const bNum = Number(bVal);
        if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return isDesc ? bNum - aNum : aNum - bNum;
      }
      aVal = aVal == null ? '' : String(aVal);
      bVal = bVal == null ? '' : String(bVal);
      const cmp = aVal.localeCompare(bVal, undefined, { numeric: true });
      return isDesc ? -cmp : cmp;
    });
  }, [projectList, sortField, sortOrder]);

  const handleSearchInputChange = (fieldName, value) => {
    setSearchCriteria((prevSearchCriteria) => ({
      ...prevSearchCriteria,
      [fieldName]: value,
    }));
  };

  const handleSearchDateSelect = (fieldName, date) => {
    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
    handleSearchInputChange(fieldName, formattedDate);
  };

  const handleColumnFilterChange = (key, value) => {
    setColumnFilters((prev) => ({ ...prev, [key]: value }));
  };

  const onUpdateClick = (record) => {
    if (record) {
      // let editData = {
      //     projectName: record.projectName,
      //     projectNumber: record.projectNumber,
      //     projectType: record.projectType,
      //     noOfPipelines: Number(record.noOfPipeline),
      //     totalCost: record.totalCost
      // };
      //console.log(record)
      projectDetailForm.setFieldsValue(record);
      seteditRecord(record);
      setIsEdit(true);
      setShowGenerateModel(true);
    }
  };
  const onClickPDFView = (record) => {
    setSelectedData(record);
    setShowPDFViewer(true);
  };
  const onDcalMasterVisibe = () => {
    setShowMasterModel(true);
  };

  const updatedColumns = columns_feild.map((column) => {
    if (column.dataIndex === 'created_date' || column.dataIndex === 'updatedDate') {
      return {
        ...column,
        title: (
          <Space style={{ display: 'flow', alignItems: 'center' }}>
            {column.title}
            <div className="date-picker">
              <DatePicker
                allowClear
                style={{ height: '30px', border: 'line' }}
                format="DD-MM-YYYY"
                placeholder="Search"
                onChange={(date) => handleSearchDateSelect(column.dataIndex, date)}
                bordered
              />
            </div>
          </Space>
        ),
      };
    } else if (column.dataIndex !== 'edit_delete' && column.dataIndex !== 'report') {
      return {
        ...column,
        title: (
          <Space style={{ display: 'flow', alignItems: 'center' }}>
            {column.title}
            <div className="searchEquip">
              <Input
                placeholder="Search"
                value={searchCriteria[column.dataIndex]}
                onChange={(e) => handleSearchInputChange(column.dataIndex, e.target.value)}
                allowClear
              />
            </div>
          </Space>
        ),
      };
    } else {
      return column;
    }
  });

  const handleProjectDetailsVisibe = () => {
    projectDetailForm.resetFields();
    setShowGenerateModel(true);
  };

  /** Display Confirmation while deleting */
  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };
  /** Deleting Spare parts data on confirm */
  const handleDeleteOk = async () => {
    setIsDeleteLoading(true);
    await DeleteProjectDetails(selectedData);
    setIsDeleteLoading(false);
    setIsDeleteModalVisible(false);
    setSelectedData('');
    const obj = {
      pageSize: currentPagesize,
      pageNumber: currentPageNumber,
    };
    if (searchCriteria && Object.keys(searchCriteria).length > 0) {
      obj.searchKey = normalizeSearchCriteria(searchCriteria);
    }
    await onProjectList(obj);
  };
  /** Cancelling the deletion of spare parts data */
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData('');
  };

  const tablePagination =
    listCount > 10
      ? {
          position: ['bottomRight'],
          className: embeddedInModernLayout ? 'heat-profile-pagination' : 'fixed-pagination',
          showSizeChanger: true,
          total: listCount,
          defaultPageSize: 10,
          defaultCurrent: 1,
          current: currentPageNumber,
          pageSize: currentPagesize,
          pageSizeOptions: ['10', '20', '50'],
          onChange: async (pageNumber, pageSize) => {
            setCurrentPageNumber(pageNumber);
            setCurrentPagesize(pageSize);
            const obj = {
              pageSize: pageSize,
              pageNumber: pageNumber,
            };
            if (searchCriteria && Object.keys(searchCriteria).length > 0) {
              obj.searchKey = normalizeSearchCriteria(searchCriteria);
            }
            await onProjectList(obj);
          },
        }
      : false;

  const refreshProjectList = async () => {
    await onProjectList(buildProjectListRequest());
  };

  if (embeddedInModernLayout && !showPDFViewer) {
    return (
      <>
        {!showPipelineModel && !showMasterModel && (
          <div className="dcal-card">
            <div className="dcal-list-header">
              <div className="dcal-header-left">
                <div className="dcal-icon-wrap">
                  <FileExcelOutlined style={{ fontSize: 22 }} />
                </div>
                <div className="dcal-header-content">
                  <div className="dcal-title-row">
                    <h3 className="dcal-list-title">List of DCAL Projects</h3>
                    <span className="dcal-summary">
                      {listCount != null ? listCount : 0} item{(listCount != null ? listCount : 0) !== 1 ? 's' : ''}
                    </span>
                  </div>
                  <p className="dcal-list-description">
                    Generate and manage DCAL project reports and master data.
                  </p>
                </div>
              </div>
              <div className="dcal-header-actions">
                <CrcButton
                  label="Create New"
                  variant="primary"
                  icon={Plus}
                  onClick={handleProjectDetailsVisibe}
                  size="medium"
                />
              </div>
            </div>
            <div className="addTeamDetails heat-profile-table-wrap">
              <Table
                columns={modernColumnsWithFilters}
                dataSource={sortedProjectList}
                rowKey="ID"
                loading={{
                  indicator: <Spinner variant="inline" size="medium" />,
                  spinning: isLoading,
                }}
                className="h-100 pipeline-table equipPaginationTable heat-profile-table"
                scroll={{ x: 1600, y: 'calc(100vh - 280px)' }}
                onChange={(pagination, filters, sorter) => {
                  if (sorter && sorter.columnKey) {
                    setSortField(sorter.columnKey);
                    setSortOrder(sorter.order || null);
                    setCurrentPageNumber(1);
                  }
                }}
                pagination={tablePagination}
              />
            </div>
          </div>
        )}
        {showGenerateModel && (
          <ProjectDetails
            setShowGenerateModel={setShowGenerateModel}
            showGenerateModel={showGenerateModel}
            setShowPipelineModel={setShowPipelineModel}
            projectDetails={projectDetails}
            setProjectDetails={setProjectDetails}
            projectDetailForm={projectDetailForm}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            seteditRecord={seteditRecord}
            editRecord={editRecord}
            useModernLayout={true}
            onRefreshProjects={refreshProjectList}
          />
        )}
        {showMasterModel && (
          <DCalMasteForm
            setShowMasterModel={setShowMasterModel}
            showMasterModel={showMasterModel}
          />
        )}
        <Modal
          width={480}
          className="dcal-delete-confirm-modal"
          title="Delete DCAL Details"
          centered
          visible={isDeleteModalVisible}
          onCancel={handleDeleteCancel}
          footer={
            <div className="materials-modal-modern-footer dcal-delete-confirm-footer">
              <CrcButton
                key="cancel"
                label="Cancel"
                variant="tertiary"
                onClick={handleDeleteCancel}
                size="medium"
              />
              <CrcButton
                key="delete"
                label={isDeleteLoading ? 'Deleting' : 'Delete'}
                variant="primary"
                onClick={handleDeleteOk}
                disabled={isDeleteLoading}
                size="medium"
              />
            </div>
          }
        >
          <div className="dcal-delete-confirm-content">
            <p className="dcal-delete-confirm-warning">
              Deleting project details will remove all corresponding and related information.
            </p>
            <p className="dcal-delete-confirm-question">
              Are you sure you want to delete{' '}
              <strong className="dcal-delete-confirm-name">
                {selectedData && selectedData.project_name}
              </strong>
              ?
            </p>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <div className="d-flex flex-column h-100">
      <div className="flex-auto">
        {!showPDFViewer && !showPipelineModel && !showMasterModel && (
          <div className="flex-auto">
            <div className="d-flex mb-3 align-items-center tab-content-title">
              <div className="back_heatp_modal">
                <Tooltip title={'Back'}>
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.push('/technical');
                    }}
                  />
                </Tooltip>
              </div>

              <Title
                className="mb-0 add-new-calibration"
                level={3}
                style={{ paddingLeft: '25px', paddingTop: '5px' }}
              >
                DCAL Generator
              </Title>
              <div className="new-calibration">
                {(userGroup &&
                  userGroup.includes('dcal-generator') &&
                  userGroup.includes('dcal-generator-master')) ||
                  userGroup.includes('super-admin') ||
                  (userGroup.includes('admin') && (
                    <Button
                      shape="round"
                      key="apply"
                      type="primary"
                      onClick={onDcalMasterVisibe}
                    >
                      Go to Database
                    </Button>
                  ))}

                <Text
                  onClick={() => handleProjectDetailsVisibe()}
                  className="ps-3 add-new-calibration"
                  style={{}}
                >
                  <span
                    className="icon-22"
                    style={{ scale: '20px' }}
                  >
                    <svg>
                      <use xlinkHref="#add" />
                    </svg>
                  </span>
                  Create New
                </Text>
              </div>
            </div>
            <div className="custom-line" />
            <Row gutter={24}>
              <Col span={24}>
                <div className="addTeamDetails">
                  <Table
                    columns={updatedColumns}
                    className="h-100 pipeline-table  equipPaginationTable"
                    scroll={{ y: 'calc(100vh - 230px)' }}
                    rowKey={'ID'}
                    pagination={tablePagination}
                    dataSource={[...projectList]}
                    loading={{
                      indicator: <Spinner variant="inline" size="medium" />,
                      spinning: isLoading,
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        )}
        {showGenerateModel && (
          <ProjectDetails
            setShowGenerateModel={setShowGenerateModel}
            showGenerateModel={showGenerateModel}
            setShowPipelineModel={setShowPipelineModel}
            projectDetails={projectDetails}
            setProjectDetails={setProjectDetails}
            projectDetailForm={projectDetailForm}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            seteditRecord={seteditRecord}
            editRecord={editRecord}
          ></ProjectDetails>
        )}
        {showPipelineModel && (
          <DcalUpdateForm
            setShowGenerateModel={setShowGenerateModel}
            showGenerateModel={showGenerateModel}
            setShowPipelineModel={setShowPipelineModel}
            showPipelineModel={showPipelineModel}
            setProjectDetails={setProjectDetails}
            projectDetails={projectDetails}
          ></DcalUpdateForm>
        )}
        {showMasterModel && (
          <DCalMasteForm
            setShowMasterModel={setShowMasterModel}
            showMasterModel={showGenerateModel}
          ></DCalMasteForm>
        )}
        <Modal
          width={480}
          className="dcal-delete-confirm-modal"
          title="Delete DCAL Details"
          centered
          visible={isDeleteModalVisible}
          onCancel={handleDeleteCancel}
          footer={
            <div className="materials-modal-modern-footer dcal-delete-confirm-footer">
              <CrcButton
                key="cancel"
                label="Cancel"
                variant="tertiary"
                onClick={handleDeleteCancel}
                size="medium"
              />
              <CrcButton
                key="delete"
                label={isDeleteLoading ? 'Deleting' : 'Delete'}
                variant="primary"
                onClick={handleDeleteOk}
                disabled={isDeleteLoading}
                size="medium"
              />
            </div>
          }
        >
          <div className="dcal-delete-confirm-content">
            <p className="dcal-delete-confirm-warning">
              Deleting project details will remove all corresponding and related information.
            </p>
            <p className="dcal-delete-confirm-question">
              Are you sure you want to delete{' '}
              <strong className="dcal-delete-confirm-name">
                {selectedData && selectedData.project_name}
              </strong>
              ?
            </p>
          </div>
        </Modal>

        {showPDFViewer && selectedData && selectedData.PDF_Files_History[0].PDFFileLink && (
          <div style={{ height: '100%' }}>
            <div>
              <div className="d-flex mb-3 align-items-center">
                <div className="back_heatp_modal">
                  <Tooltip title={'Back'}>
                    <ArrowLeftOutlined
                      onClick={() => {
                        setShowPDFViewer(false);
                        //  history.push('/TechnicalPage');
                      }}
                    />
                  </Tooltip>
                </div>

                <Title
                  className="mb-0 add-new-calibration"
                  level={3}
                  style={{ paddingLeft: '30px' }}
                >
                  {'Report Viewer'}
                </Title>

                <div className="new-calibration"></div>
              </div>
              <div className="pdf-container">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={selectedData.PDF_Files_History[0].PDFFileLink}
                    plugins={[defaultLayoutPluginInstance]}
                  />
                </Worker>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = ({ DCALReducer }) => {
  const projectList = get(DCALReducer, 'ProjectList', []);
  // console.log(projectList)
  const isLoading = get(DCALReducer, 'isProjectFetchLoading', false);
  const listCount = get(DCALReducer, 'ProjectListCount', null);

  return {
    projectList,
    isLoading,
    listCount,
  };
};

const mapDispatchToProps = {
  onProjectList: fetchProjectList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DCalPage);
